<template>
  <div class="matching-information-container" @input="onCriteriaInput">
    <div
      v-if="currentUserMatchingTemplateRef"
      v-html="
        prepareMatchingInformationHTML(
          currentUserMatchingTemplateRef ? currentUserMatchingTemplateRef : '',
          userAlreadyFilledCriteriaRef ? userAlreadyFilledCriteriaRef : [],
        )
      "
    ></div>
    <div v-else class="matching-content-loading">
      <LoadingIcon color="primary" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from 'vue'

import useMatchingInformation from '@/features/matching/hooks/use-matching-information.hook'
import LoadingIcon from '@/features/ui/components/icons/loading-icon.vue'
import modalsStore from '@/features/ui/store/modal/modal.store'

const {
  currentUserMatchingTemplateRef,
  mentorCriteriaRef,
  menteeCriteriaRef,
  prepareMatchingInformationHTML,
  onCriteriaInput,
  resetCriteriaDraft,
} = useMatchingInformation({
  onSubmitCallback: () => null,
})

// Les inputs sont recréés à chaque montage du formulaire (v-html) : le
// brouillon de saisie partagé repart des valeurs serveur à ce moment-là.
onMounted(resetCriteriaDraft)
onBeforeUnmount(resetCriteriaDraft)

// Sélectionne les critères appropriés selon le rôle du modal
const userAlreadyFilledCriteriaRef = computed(() => {
  // Si le modal mentee-matching ou new-matching est ouvert, utiliser les critères mentee
  if (modalsStore.modals['mentee-matching'].isOpen || modalsStore.modals['new-matching'].isOpen) {
    return menteeCriteriaRef.value
  }

  // Si le modal mentor-matching est ouvert, utiliser les critères mentor
  if (modalsStore.modals['mentor-matching'].isOpen) {
    return mentorCriteriaRef.value
  }

  // Si le modal program-criterias est ouvert, vérifier le rôle attaché
  const role = (modalsStore.modals['program-criterias'].attachedData as { role?: 'mentor' | 'mentee' })?.role
  if (role === 'mentee') {
    return menteeCriteriaRef.value
  }
  return mentorCriteriaRef.value
})
</script>

<style lang="scss"></style>
